export const ICON_NAME = {
  Actor: 'Icon_Actor',
  SceneComponent: 'Icon_SceneComponent',
  Component: 'Icon_Component',
  MeshComponent: 'Icon_Mesh',
  GLFTMeshComponent: 'Icon_GLTFMesh'
} as const;
export type ICON_NAME = (typeof ICON_NAME)[keyof typeof ICON_NAME];
